import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokolhapurcab() {



    const cardData = {




keyword: "Mumbai to Kolhapur Cab",

headingDescription: "Shreesha Tours & Travels provides safe, reliable, and affordable Mumbai to Kolhapur cab services for families, business travelers, tourists, pilgrims, and corporate clients. We offer one-way cabs, round-trip taxi services, airport transfers, and customized outstation travel packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars suitable for solo travelers, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support, we ensure a smooth, comfortable, and hassle-free journey. Whether you are planning a pilgrimage to Mahalaxmi Temple, a business trip, a family vacation, a weekend getaway, or a sightseeing tour, Shreesha Tours & Travels offers dependable Mumbai to Kolhapur cab services with clean vehicles, courteous drivers, and exceptional customer service. Enjoy a comfortable highway journey while exploring the rich history, culture, temples, forts, and famous attractions of Kolhapur.",

topPlaces: [
  {
    title: "Mahalaxmi Temple",
    description: "Shri Mahalaxmi Temple is one of the most revered Shakti Peethas in India and the most famous attraction in Kolhapur. Dedicated to Goddess Mahalaxmi, the temple welcomes millions of devotees every year. Its ancient architecture, spiritual atmosphere, and historical importance make it a must-visit destination for pilgrims and tourists alike."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is one of Maharashtra's largest and most historic hill forts, closely associated with Chhatrapati Shivaji Maharaj. The fort offers magnificent views of the Sahyadri hills, impressive gateways, ancient structures, and rich Maratha history, making it a favorite destination for history enthusiasts."
  },
  {
    title: "Rankala Lake",
    description: "Rankala Lake is a beautiful recreational spot in Kolhapur known for its peaceful waterfront, boating facilities, gardens, horse rides, and evening food stalls. Families and couples visit the lake to relax, enjoy scenic sunsets, and spend quality leisure time."
  },
  {
    title: "Jyotiba Temple",
    description: "Located on a hill near Kolhapur, Jyotiba Temple is a prominent pilgrimage destination dedicated to Lord Jyotiba. The temple is especially crowded during annual fairs and festivals and offers breathtaking panoramic views of the surrounding hills and countryside."
  },
  {
    title: "New Palace Museum",
    description: "The New Palace Museum showcases the royal heritage of the Kolhapur royal family with an impressive collection of weapons, paintings, artifacts, costumes, and historical memorabilia. It is an ideal destination for visitors interested in Maharashtra's royal history and culture."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi is a famous pilgrimage town located near Kolhapur and is dedicated to Lord Dattatreya. Situated on the banks of the Krishna River, it attracts thousands of devotees seeking spiritual peace and blessings throughout the year."
  },
  {
    title: "Dajipur Wildlife Sanctuary",
    description: "Dajipur Wildlife Sanctuary, also known as Radhanagari Wildlife Sanctuary, is famous for its rich biodiversity, dense forests, Indian bison (Gaur), birdlife, and scenic natural beauty. It is an excellent destination for wildlife lovers and nature enthusiasts."
  },
  {
    title: "Amba Ghat",
    description: "Amba Ghat is a picturesque mountain pass connecting Kolhapur with the Konkan region. Known for its winding roads, lush greenery, waterfalls during monsoon, and spectacular viewpoints, it is a favorite destination for road trip enthusiasts."
  },
  {
    title: "Ganpatipule",
    description: "Ganpatipule is a beautiful coastal destination located within driving distance of Kolhapur. Famous for the self-originated Ganpati Temple, pristine beaches, water sports, and scenic Konkan coastline, it is often included in extended Maharashtra holiday itineraries."
  },
  {
    title: "Amboli Hill Station",
    description: "Amboli is a charming hill station located near Kolhapur, renowned for its mist-covered valleys, waterfalls, pleasant climate, viewpoints, and biodiversity. It is a perfect destination for weekend getaways, monsoon tourism, and family vacations."
  }
],



"services": [
  {
    "name": "Mumbai to Kolhapur Cab",
    "description": "Book Mumbai to Kolhapur Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, and luxury cabs for one way and round trip journeys."
  },
  {
    "name": "Mumbai Airport to Kolhapur Cab",
    "description": "Hire Mumbai Airport to Kolhapur Cab with direct airport pickup, experienced drivers, and comfortable AC vehicles for hassle-free travel."
  },
  {
    "name": "Mumbai Kolhapur Cab Service",
    "description": "Choose Mumbai Kolhapur Cab Service for dependable long-distance transportation with affordable fares and premium chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Kolhapur Car Rentals",
    "description": "Book Mumbai to Kolhapur Car Rentals with flexible packages, multiple vehicle options, and professional chauffeurs for comfortable travel."
  },
  {
    "name": "Mumbai to Kolhapur Cab",
    "description": "Reserve Mumbai to Kolhapur Cab with clean AC vehicles, transparent pricing, and reliable service for business, family, and personal travel."
  },
  {
    "name": "Mumbai to Kolhapur Taxi",
    "description": "Hire Mumbai to Kolhapur Taxi with experienced drivers, comfortable seating, and affordable fares for one way and round trip journeys."
  },
  {
    "name": "Mumbai to Kolhapur Cab Service",
    "description": "Book Mumbai to Kolhapur Cab Service with premium vehicles, professional chauffeurs, and flexible booking options."
  },
  {
    "name": "Mumbai to Kolhapur Taxi Service",
    "description": "Choose Mumbai to Kolhapur Taxi Service for reliable intercity transportation with well-maintained vehicles and skilled drivers."
  },
  {
    "name": "Mumbai to Kolhapur One Way Cab",
    "description": "Reserve Mumbai to Kolhapur One Way Cab with fixed pricing, no return charges, and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Kolhapur Cab Booking",
    "description": "Complete Mumbai to Kolhapur Cab Booking online with instant confirmation, multiple vehicle choices, and affordable travel packages."
  },
  {
    "name": "Mumbai to Kolhapur Car Rental",
    "description": "Book Mumbai to Kolhapur Car Rental for private chauffeur-driven travel with Sedan, SUV, Innova Crysta, and Ertiga options."
  },
  {
    "name": "Mumbai to Kolhapur Outstation Cab",
    "description": "Hire Mumbai to Kolhapur Outstation Cab for convenient interstate travel with experienced chauffeurs and comfortable AC vehicles."
  },
  {
    "name": "Mumbai to Kolhapur Private Taxi",
    "description": "Choose Mumbai to Kolhapur Private Taxi for personalized travel with dedicated vehicles and professional drivers."
  },
  {
    "name": "Mumbai to Kolhapur Innova Cab",
    "description": "Book Mumbai to Kolhapur Innova Cab for spacious and comfortable travel ideal for families and business groups."
  },
  {
    "name": "Mumbai to Kolhapur Innova Crysta Cab",
    "description": "Reserve Mumbai to Kolhapur Innova Crysta Cab with premium interiors, luxury seating, and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Kolhapur Ertiga Cab",
    "description": "Hire Mumbai to Kolhapur Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating."
  },
  {
    "name": "Mumbai to Kolhapur Sedan Cab",
    "description": "Book Mumbai to Kolhapur Sedan Cab for economical and comfortable travel with clean AC vehicles and professional drivers."
  },
  {
    "name": "Mumbai to Kolhapur Swift Dzire Cab",
    "description": "Choose Mumbai to Kolhapur Swift Dzire Cab for budget-friendly travel with excellent comfort and fuel-efficient performance."
  },
  {
    "name": "Mumbai to Kolhapur SUV Cab",
    "description": "Reserve Mumbai to Kolhapur SUV Cab for spacious travel with extra luggage capacity and comfortable long-distance journeys."
  },
  {
    "name": "Mumbai to Kolhapur Kia Carens Cab",
    "description": "Book Mumbai to Kolhapur Kia Carens Cab for premium family travel with spacious seating and modern comfort."
  },
  {
    "name": "Mumbai to Kolhapur Tempo Traveller",
    "description": "Hire Mumbai to Kolhapur Tempo Traveller for group tours, family trips, and corporate outings with ample seating capacity."
  },
  {
    "name": "Mumbai to Kolhapur Luxury Cab",
    "description": "Choose Mumbai to Kolhapur Luxury Cab for premium travel experience with high-end vehicles and professional chauffeurs."
  },
  {
    "name": "Mumbai Airport to Kolhapur Cab",
    "description": "Book Mumbai Airport to Kolhapur Cab with timely airport pickup, comfortable vehicles, and reliable chauffeur service."
  },
  {
    "name": "Navi Mumbai to Kolhapur Cab",
    "description": "Reserve Navi Mumbai to Kolhapur Cab with affordable pricing and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Thane to Kolhapur Cab",
    "description": "Hire Thane to Kolhapur Cab for smooth intercity travel with experienced drivers and premium AC vehicles."
  },
  {
    "name": "Panvel to Kolhapur Cab",
    "description": "Book Panvel to Kolhapur Cab with reliable transportation, flexible schedules, and comfortable vehicles."
  },
  {
    "name": "Dadar to Kolhapur Taxi",
    "description": "Choose Dadar to Kolhapur Taxi for convenient travel with professional chauffeurs and affordable fares."
  },
  {
    "name": "Borivali to Kolhapur Cab",
    "description": "Reserve Borivali to Kolhapur Cab with comfortable vehicles and reliable long-distance taxi services."
  },
  {
    "name": "Andheri to Kolhapur Cab",
    "description": "Book Andheri to Kolhapur Cab with doorstep pickup, experienced drivers, and premium travel comfort."
  },
  {
    "name": "Kalyan to Kolhapur Cab",
    "description": "Hire Kalyan to Kolhapur Cab with clean AC vehicles, transparent pricing, and flexible travel options."
  },
  {
    "name": "Mumbai International Airport to Kolhapur Cab",
    "description": "Book Mumbai International Airport to Kolhapur Cab with direct airport pickup and reliable chauffeur-driven service."
  },
  {
    "name": "T2 Airport Mumbai to Kolhapur Taxi",
    "description": "Reserve T2 Airport Mumbai to Kolhapur Taxi with comfortable vehicles and timely airport pickup services."
  },
  {
    "name": "One Way Cab Mumbai to Kolhapur",
    "description": "Choose One Way Cab Mumbai to Kolhapur for economical single-trip travel with fixed fares and no return charges."
  },
  {
    "name": "Mumbai to Kolhapur Taxi Booking Online",
    "description": "Complete Mumbai to Kolhapur Taxi Booking Online with instant confirmation and multiple vehicle options."
  },
  {
    "name": "Mumbai to Kolhapur Outstation Taxi Service",
    "description": "Hire Mumbai to Kolhapur Outstation Taxi Service for safe, reliable, and comfortable interstate travel."
  },
  {
    "name": "Mumbai to Kolhapur Family Trip Cab",
    "description": "Book Mumbai to Kolhapur Family Trip Cab with spacious vehicles and experienced chauffeurs for comfortable family journeys."
  },
  {
    "name": "Mumbai to Kolhapur Tourist Cab",
    "description": "Choose Mumbai to Kolhapur Tourist Cab for sightseeing, vacations, and holiday travel with premium vehicles."
  },
  {
    "name": "Mumbai to Kolhapur Corporate Cab Service",
    "description": "Reserve Mumbai to Kolhapur Corporate Cab Service for executive travel, employee transportation, and business trips."
  },
  {
    "name": "Mumbai to Kolhapur Door to Door Taxi",
    "description": "Book Mumbai to Kolhapur Door to Door Taxi with doorstep pickup and drop for convenient and hassle-free travel."
  },
  {
    "name": "Mumbai to Kolhapur Same Day Cab",
    "description": "Hire Mumbai to Kolhapur Same Day Cab with flexible schedules and reliable chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Kolhapur Highway Taxi",
    "description": "Choose Mumbai to Kolhapur Highway Taxi for smooth highway travel with experienced drivers and comfortable vehicles."
  },
  {
    "name": "Mumbai to Kolhapur Travel Service",
    "description": "Book Mumbai to Kolhapur Travel Service with professional chauffeurs, premium vehicles, and customized travel solutions."
  }
],
"tableData": [
  ["Mumbai to Kolhapur Cab", "Mumbai Airport to Kolhapur Cab"],
  ["Mumbai Kolhapur Cab Service", "Mumbai to Kolhapur Car Rentals"],
  ["Mumbai to Kolhapur Taxi", "Mumbai to Kolhapur Cab Service"],
  ["Mumbai to Kolhapur Taxi Service", "Mumbai to Kolhapur One Way Cab"],
  ["Mumbai to Kolhapur Cab Booking", "Mumbai to Kolhapur Car Rental"],
  ["Mumbai to Kolhapur Outstation Cab", "Mumbai to Kolhapur Private Taxi"],
  ["Mumbai to Kolhapur Innova Cab", "Mumbai to Kolhapur Innova Crysta Cab"],
  ["Mumbai to Kolhapur Ertiga Cab", "Mumbai to Kolhapur Sedan Cab"],
  ["Mumbai to Kolhapur Swift Dzire Cab", "Mumbai to Kolhapur SUV Cab"],
  ["Mumbai to Kolhapur Kia Carens Cab", "Mumbai to Kolhapur Tempo Traveller"],
  ["Mumbai to Kolhapur Luxury Cab", "Navi Mumbai to Kolhapur Cab"],
  ["Thane to Kolhapur Cab", "Panvel to Kolhapur Cab"],
  ["Dadar to Kolhapur Taxi", "Borivali to Kolhapur Cab"],
  ["Andheri to Kolhapur Cab", "Kalyan to Kolhapur Cab"],
  ["Mumbai International Airport to Kolhapur Cab", "T2 Airport Mumbai to Kolhapur Taxi"],
  ["One Way Cab Mumbai to Kolhapur", "Mumbai to Kolhapur Taxi Booking Online"],
  ["Mumbai to Kolhapur Outstation Taxi Service", "Mumbai to Kolhapur Family Trip Cab"],
  ["Mumbai to Kolhapur Tourist Cab", "Mumbai to Kolhapur Corporate Cab Service"],
  ["Mumbai to Kolhapur Door to Door Taxi", "Mumbai to Kolhapur Same Day Cab"],
  ["Mumbai to Kolhapur Highway Taxi", "Mumbai to Kolhapur Travel Service"]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Kolhapur Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels provides reliable Mumbai to Kolhapur cab services with well-maintained vehicles, experienced chauffeurs, and convenient travel solutions for families, business travellers, and tourists."
  },
  {
    WhyChooseheading: "Safe & Hassle-Free Long Distance Journey",
    WhyChoosedescription: "Travel comfortably from Mumbai to Kolhapur with doorstep pickup, direct drop service, and flexible travel timings that make your journey smooth and stress-free."
  },
  {
    WhyChooseheading: "Wide Range of Premium Vehicles",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Multi-Day Booking",
    WhyChoosedescription: "Whether you need a one-way transfer, a return journey, or a customized multi-day travel plan, we offer flexible cab packages to suit your itinerary."
  },
  {
    WhyChooseheading: "Professional Drivers with Highway Experience",
    WhyChoosedescription: "Our skilled chauffeurs are experienced on long-distance routes and ensure a safe, punctual, and comfortable journey throughout your trip."
  },
  {
    WhyChooseheading: "Ideal for Business, Pilgrimage & Family Travel",
    WhyChoosedescription: "Our Mumbai to Kolhapur taxis are suitable for Mahalaxmi Temple visits, corporate travel, educational tours, shopping trips, family vacations, and personal travel."
  },
  {
    WhyChooseheading: "Clean, Spacious & Well-Maintained Fleet",
    WhyChoosedescription: "Every vehicle is regularly serviced and features comfortable seating, clean interiors, air conditioning, and ample luggage space for a pleasant travel experience."
  },
  {
    WhyChooseheading: "Simple Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking assistance, and dedicated customer support when reserving your Mumbai to Kolhapur cab."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Kolhapur Cab Service?",
    answer: "Yes, we provide Mumbai to Kolhapur cab services for one-way, round-trip, business, family, and pilgrimage travel."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Kolhapur?",
    answer: "Yes, one-way taxi services are available for passengers travelling directly from Mumbai to Kolhapur."
  },
  {
    question: "Which vehicles are available for Mumbai to Kolhapur travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is the cab suitable for family and group travel?",
    answer: "Yes, our spacious vehicles are ideal for families, senior citizens, business travellers, and groups."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Kolhapur?",
    answer: "Yes, we offer flexible round-trip packages with return schedules based on your travel plans."
  },
  {
    question: "Can I include sightseeing during my Kolhapur trip?",
    answer: "Yes, you can customize your journey by including places like Mahalaxmi Temple, Rankala Lake, Panhala Fort, and other attractions."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Toll charges, parking fees, permits, and other applicable charges depend on the selected package and are explained before booking."
  },
  {
    question: "Is Mumbai to Kolhapur cab service available 24/7?",
    answer: "Yes, Shreesha Tours & Travels provides cab booking assistance throughout the day for advance and scheduled travel."
  },
  {
    question: "How can I book a Mumbai to Kolhapur Cab?",
    answer: "Share your pickup location, travel date, destination, passenger details, and preferred vehicle to receive a fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback: "Our Mumbai to Kolhapur journey with Shreesha Tours & Travels was excellent. The cab was clean, the driver was professional, and the trip was comfortable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Patil",
    feedback: "We booked an Innova Crysta for a family visit to Kolhapur. The booking process was easy, the vehicle was spacious, and the overall service was outstanding.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kolhapur Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-kolhapur-cab.webp",
  "description":
    "Book Mumbai to Kolhapur Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Kolhapur with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, Mahalakshmi Temple visits, family trips, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-kolhapur-cab"
  }
};






    return (
        <div>
<Helmet>
  <title>Mumbai to Kolhapur Cab | Intercity Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Kolhapur Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable travel from Mumbai or Mumbai Airport to Kolhapur with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Kolhapur Cab, Mumbai Airport to Kolhapur Cab, Mumbai Kolhapur Cab Service, Mumbai to Kolhapur Car Rentals, Mumbai to Kolhapur Taxi, Mumbai to Kolhapur Taxi Service, Mumbai to Kolhapur One Way Cab, Mumbai to Kolhapur Round Trip Cab, Mumbai to Kolhapur Cab Booking, Mumbai to Kolhapur Taxi Booking, Mumbai to Kolhapur Innova Cab, Mumbai to Kolhapur Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitokolhapurcab;